<template>
  <div class="pb-5" >
    <form v-if="product"  v-on:submit.prevent>
      <div>
        <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <ShoppingCartIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
              @input="v$.product.name.$touch"
              v-model="product.name"
              type="text"
              name="name"
              id="name"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
              placeholder="Product Name" />

        </div>
        <div
            v-if="v$.product.name.$dirty"
            v-for="error in v$.product.name.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
      </div>
      <div class="mt-3">
        <label for="minimum" class="block text-sm font-medium text-gray-700">Minimum Outreach Cycle</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <input
              @input="v$.product.minimumOutreachCycle.$touch"
              v-model.number="product.minimumOutreachCycle"
              type="text"
              name="minimum"
              id="minimum"
              class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="28" />

        </div>
        <div
            v-if="v$.product.minimumOutreachCycle.$dirty"
            v-for="error in v$.product.minimumOutreachCycle.$silentErrors"
            :key="error.$uid"
            class="error-msg mt-1 ml-5 text-red-500 font-bold">
          <small>
            {{ error.$message }}
          </small>
        </div>
      </div>
      <div class="mt-3">
        <label for="email-setting" class="block text-sm font-medium text-gray-700">Email Settings</label>
        <div class="mt-1 relative rounded-md shadow-sm" :class="product.emailServerSettingId==null ? 'text-gray-400' : ''">
          <select v-model="product.emailServerSettingId" name="emailSetting" class="native-select">
            <option disabled value=null>Select an Email Setting</option>
            <option class="text-black" v-for="setting in emailSettings" :value="setting.id" >{{ setting.fromEmail }}</option>
          </select>
        </div>
      </div>

      <div class="mt-3">
        <h1 class="text-xl">
          Outreach Templates
        </h1>
      </div>
      <div
          class="mt-1"
          v-if="templates.length > 0"
          v-for="(outreach, index) in outreaches">
        <div v-if="shouldDisplaySelect(outreach)">
          <label
              for="location"
              class="native-select-label">
            Outreach # {{ index + 1 }}
          </label>
          <select
              v-model="product[outreach]"
              name="location"
              class="native-select"
              :class="product[outreach]==null ? 'text-gray-400' : ''">
            <option disabled value=null>Select a Template</option>
            <option
                class="text-black"
                v-for="template in templates"
                :value="template.id">{{ template.name }}</option>
          </select>
          <div
              v-if="getLastOutreach() === outreach"
              class="mt-3">
            <button
                @click="addOutreach(index)"
                :disabled="(index + 1) === outreaches.length"
                class="text-brand-primary outreach-button">
              <PlusCircleIcon class="h-6 w-6" /></button>
            <button
                @click="deleteOutreach(index)"
                :disabled="index === 0"
                class="text-brand-danger outreach-button">
              <MinusCircleIcon class="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>
      <div class="mt-1" v-else>
        <div>
         <p>Oops!! Looks like you need to add some templates first!</p>
        </div>
      </div>
      <div class="my-3">
        <primary-button
            :disabled="v$.$invalid"
            @click="handleUpdateProduct"
            text="Update Product" />
      </div>
    </form>
  </div>
</template>

<script>
import { ShoppingCartIcon } from '@heroicons/vue/solid'
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import gravyAxios from "@/plugins/axios";
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, SelectorIcon, PlusCircleIcon, MinusCircleIcon } from '@heroicons/vue/solid'
import useVuelidate from "@vuelidate/core";
import { required, between } from "@vuelidate/validators";

export default {
  name: "UpdateProductsForm",
  components: {
    ShoppingCartIcon,
    PrimaryButton,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
    PlusCircleIcon,
    MinusCircleIcon
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      outreaches: templateRelations
    }
  },
  computed: {
    product() {
      return this.$store.getters.getProduct
    },
    emailSettings() {
      return this.$store.getters.getEmailSettings
    },
    templates() {
      return this.$store.getters.getTemplates
    }
  },
  methods: {
    addOutreach(index) {
      this.product[this.outreaches[index+1]] = null
    },
    deleteOutreach(index) {
      delete this.product[this.outreaches[index]]
    },
    shouldDisplaySelect(outreach) {
      if (this.product[outreach] !== undefined) {
        return true
      }
      if (!this.product[this.outreaches[0]] && outreach === this.outreaches[0]) {
        this.product[this.outreaches[0]] = null
        return true
      }
      if (this.outreaches.indexOf(outreach) < this.outreaches.indexOf(this.getLastOutreach())) {
        this.product[outreach] = null
        return true
      }
    },
    shouldDisplayButtons(outreach) {
      if (this.getLastOutreach() === outreach) {
        return true
      }
    },
    getLastOutreach() {
      let lastOutreach = this.outreaches[0]
      this.outreaches.forEach((outreach, index) => {
        if (this.product[outreach] !== undefined) {
          lastOutreach = outreach
        }
      })
      return lastOutreach
    },
    async handleUpdateProduct() {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('updateProduct', this.product)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Product Successfully Updated'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('closeUpdateProductPanel')
      this.$store.dispatch('hideLoadingSpinner')

    },

  },
  validations: {
    product: {
      name: { required },
      minimumOutreachCycle: { between: between(7, 28) },
    }
  }

}

let templateRelations = [
    "outreachTemplateOne", "outreachTemplateTwo", "outreachTemplateThree", "outreachTemplateFour",
    "outreachTemplateFive", "outreachTemplateSix", "outreachTemplateSeven", "outreachTemplateEight",
    "outreachTemplateNine", "outreachTemplateTen", "outreachTemplateEleven", "outreachTemplateTwelve",
    "outreachTemplateThirteen", "outreachTemplateFourteen", "outreachTemplateFifteen", "outreachTemplateSixteen",
    "outreachTemplateSeventeen", "outreachTemplateEighteen", "outreachTemplateNineteen", "outreachTemplateTwenty",]

</script>

<style scoped>
  .outreach-button:disabled {
    @apply text-gray-500
  }
</style>
